import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Dialog } from '@mui/material';

import EmailSent from '../icons/EmailSent';

type PasswordChangeSentDialogProps = {
  open: boolean;
  handleOnClose: () => void;
};

const PasswordChangeSentDialog = ({
  open,
  handleOnClose,
}: PasswordChangeSentDialogProps) => {
  const { watch } = useFormContext();

  return (
    <Dialog
      open={open}
      onClose={handleOnClose}
      aria-labelledby="alertTitle"
      aria-describedby="alertContent"
    >
      <div className="flex flex-col items-center gap-3 p-8">
        <EmailSent />
        <h2 className="text-xl font-bold">Check your email</h2>
        <div className="text-center text-base text-[#666]">
          <p>
            If an account exists with{' '}
            <span className="font-bold">{watch('email')}</span>, we’ve sent
            instructions to reset your password. The message may take a few
            minutes to arrive.
          </p>
        </div>
      </div>
    </Dialog>
  );
};

export default PasswordChangeSentDialog;
